import {useNavigation, useRoute} from '@react-navigation/native';
import {Button, Layout} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet} from 'react-native';
import {getImage} from '../../helpers/general';
import {AUTHENTICATED_ROUTES} from '../../navigation/constants';
import {px} from '../../utils';
import {Page} from '../components';
import Cover from './components/Cover';
import Description from './components/Description';

const PackageDetails = () => {
  const navigation = useNavigation();
  const {params} = useRoute();
  const {gradeName, type, image, price, description} = params.data;

  return (
    <Page header={{title: 'Package Details', showBackAction: true}}>
      <Cover imageUrl={getImage(image)} title={type} price={price} />
      <Layout style={styles.body}>
        <Description description={`Grade: ${gradeName}`} />

        <Description style={styles.description} description={description} />
        <Button
          style={styles.btn}
          onPress={() =>
            navigation.navigate(AUTHENTICATED_ROUTES.configurePackage.path, {
              data: params.data,
            })
          }>
          {'Purchase'}
        </Button>
      </Layout>
    </Page>
  );
};

const styles = StyleSheet.create({
  body: {
    padding: px(17),
  },
  description: {
    marginTop: px(10),
  },
  btn: {
    marginTop: px(40),
  },
});

export default PackageDetails;
